import React, { memo } from "react";
import t from "../../../../i18n";
import Tab from "@ui/NavV2/Tab";
import { useTranslations } from "../../../../api/useTranslations";
import { toPath } from "../../../../router/helpers/path";

/**
 * @note Prefere to collocate within the Dashboards module from a feature-flag standpoint.
 */
export const ProjectDashboardNavLink = memo(({ projectId }: { projectId: string }) => {
  const translations = useTranslations();

  return (
    <Tab
      key="dashboards"
      to={toPath("/projects/:projectId/dashboards", { projectId })}
      theme="dark"
    >
      {t("project.dashboards.navigation", translations)}
    </Tab>
  );
});
